// Operations routes
export default [
  {
    path: 'operations',
    name: 'baseArchives',
    redirect: 'operations/index',
    component: () =>
      import(
        /* webpackChunkName: "operations" */ '../views/operations/Operations.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'operations',
        meta: {
          tabbable: true,
          tableKeys: ['operations'],
          filterKeys: ['operations'],
          formKeys: ['operations'],
          routePermissions: ['operationsView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "operationsIndex" */ '../views/operations/OperationsIndex.vue'
          ),
      },
    ],
  },
];
